import { useEffect } from 'react'

import { DOMAIN, GETSAFE_TYPEFORM_DOMAIN, WEB_BUYING_FLOW_DOMAIN } from '@/config/env'

// This hook is used to add the current url's query parameters to all
// links to our domain, including links to WBF. This is a way to pass
// query parameters such as utm and other marketing tags around, so
// that they are finally passed to WBF
export const useAppendCurrentQueryParametersToAnchorTags = () => {
  useEffect(() => {
    document.querySelectorAll('a').forEach((a) => {
      if (
        a.href.includes(DOMAIN) ||
        a.href.includes(WEB_BUYING_FLOW_DOMAIN) ||
        a.href.includes(GETSAFE_TYPEFORM_DOMAIN)
      ) {
        const searchParams = new URL(a.baseURI).searchParams
        const newHref = new URL(a.href)

        for (const [key, value] of searchParams.entries()) {
          if (!newHref.searchParams.has(key)) {
            newHref.searchParams.append(key, value)
          }
        }

        a.href = newHref.toString()
      }
    })
  }, [])
}
